// src/api/events.js
import { requestJson } from './http';

// Get calendar events for the calendar/admin views
export function getEvents() {
  // Backend should return: [{ title, start, end, type, vrm, vehicle_id, ... }, ...]
  return requestJson('/events');
}
